export class Message {
    id: string;
    chatId: string;
    messageText: string;
    date: Date;
    sent: boolean;
    type: string;
    constructor() {
        this.id = '';
        this.chatId = '';
        this.messageText = '';
        this.date = new Date();
        this.sent = false;
        this.type = ''; // received send
    }
}
